import { graphql, Link } from "gatsby";
import React from "react";
import Loading from "../components/atoms/Loading/Loading";
import Richtext from "../components/atoms/Richtext/Richtext";
import Layout from "../components/global/Layout/Layout";
import { formatPageData } from "../components/global/Layout/utils";
import SEO from "../components/global/SEO/SEO";
import PagePadding from "../components/templates/PagePadding/PagePadding";
import Section from "../components/templates/Section/Section";
import {
  PageContent,
  PageData,
  SiteLocale,
  SiteLocales,
  SiteSettings,
  SiteTranslations,
} from "../templates/Page/types";
import { sortLocales } from "../templates/Page/utils";
import { navigateToLocalePage } from "../utils/navigate";

interface Props {
  data: {
    sanitySetting: SiteSettings;
    allSanityLanguage: SiteLocales;
    allSanityTranslation: SiteTranslations;
    sanityPage: PageData;
  };
  uri: string;
  pageContext: PageContent;
}

const NotFoundPage = (props: Props) => {
  const site = props.data.sanitySetting;
  const locales = props.data.allSanityLanguage.edges
    .map((x) => x.node)
    .sort(sortLocales);
  const page = formatPageData(site, props.data.sanityPage);

  const renderLocale = (locale: SiteLocale) => {
    return (
      <li key={locale.id} className="index__language">
        <Link to={`/${locale.locale.current}`}>{locale.localName}</Link>
      </li>
    );
  };

  React.useEffect(() => {
    navigateToLocalePage(navigator.language.toLowerCase() || "en", "");
  }, []);

  return (
    <Layout header={page.header} footer={page.footer}>
      <SEO
        locale={page.locale}
        title={site.brand}
        titleSuffix={` ${site.tagline}`}
        description={site.description}
        favicon={site.favicon.asset.url}
      />
      <Section>
        <PagePadding>
          <div className="index">
            <Loading
              size={100}
              className="index__loading"
            />
            <h1 className="index__headline">{site.homepage.title}</h1>
            <div className="index__text">
              <Richtext blocks={site.homepage._rawText} />
            </div>
            <ul className="index__languages">
              {locales.map((x) => renderLocale(x))}
            </ul>
          </div>
        </PagePadding>
      </Section>
    </Layout>
  );
};

export const query = graphql`
  query {
    ...settings
    ...languages
    ...translations
    ...pageByLocale
  }
`;

export default NotFoundPage;
